import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import ProblemDetail from "./pages/ProblemDetail";
import VibeCodingWindow from "./pages/VibeCodingWindow";
import StandaloneVibeCoder from "./pages/StandaloneVibeCoder";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/problem/:id" element={<ProblemDetail />} />
          <Route path="/build/:id" element={<VibeCodingWindow />} />
          <Route path="/vibe-coder" element={<StandaloneVibeCoder />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
